import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface CheckboxFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function CheckboxField({ field, value, onChange }: CheckboxFieldProps) {
  const config = field.config;
  const options = config.options || [];
  const layout = config.choiceLayout || 'vertical';
  const selectedValues = Array.isArray(value) ? value : [];

  const handleChange = (optionValue: string, checked: boolean) => {
    if (checked) {
      onChange([...selectedValues, optionValue]);
    } else {
      onChange(selectedValues.filter((v: string) => v !== optionValue));
    }
  };

  return (
    <div className={cn(
      "easyforms-options-group",
      layout === 'horizontal' && "flex flex-wrap gap-3",
      layout === 'grid' && `grid grid-cols-${config.columns || 2} gap-3`
    )}>
      {options.map((option, index) => (
        <div key={option.id || option.value || `checkbox-${index}`} className="easyforms-option-item">
          <input
            type="checkbox"
            id={`${field.id}-${option.value}`}
            checked={selectedValues.includes(option.value)}
            onChange={(e) => handleChange(option.value, e.target.checked)}
            className="easyforms-option-input"
          />
          <label
            htmlFor={`${field.id}-${option.value}`}
            className="easyforms-option-label"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}
